import {h, Fragment} from "preact"
import { usePagination, useActions } from '@nosto/preact'

export default () => {
    const pagination = usePagination({
        width: 5
    })
    const { updateSearch } = useActions()

    const createCallback = (from) => () => {
        updateSearch({
            products: {
                from,
            },
        })
        scrollTo(0, 0)
    }

    if(pagination.totalPages <= 1) return

    return (
        <div class="pagination">
            <div class="pagination__nav">
                {pagination.prev && (
                    <a href="javascript:void(0)"
                        class="pagination__nav-item heading heading--small"
                        rel="prev"
                        aria-label="Previous"
                        onClick={createCallback(pagination.prev.from)}
                    >
                        <span aria-hidden="true">
                            <svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1.2" fill="none"></path></svg>
                        </span>
                    </a>
                )}
                {pagination.current.page >= 4 && (
                    <a href="javascript:void(0)"
                        class="pagination__nav-item heading heading--small"
                        onClick={createCallback(0)}
                    >
                        1
                    </a>
                )}
                {pagination.first && <span class="pagination__nav-item heading heading--small">...</span>}
                {pagination.pages.map((page) => (page.current
                    ?   <span class="pagination__nav-item heading heading--small" aria-current="page">{page.page}</span>
                    :   <a href="javascript:void(0)"
                            class="pagination__nav-item  heading heading--small"
                            onClick={createCallback(page.from)}
                        >
                            {page.page}
                        </a>
                ))}
                {pagination.last && <span class="pagination__nav-item heading heading--small">...</span>}
                {pagination.current.page <= (pagination.totalPages - 3) && (
                    <a href="javascript:void(0)"
                        class="pagination__nav-item heading heading--small"
                        onClick={createCallback((pagination.totalPages - 1) * (pagination.pages[1]?.from))}
                    >
                        {pagination.totalPages}
                    </a>
                )}
                {pagination.next && (
                    <a href="javascript:void(0)"
                        class="pagination__nav-item  heading heading--small"
                        rel="next"
                        aria-label="Next"
                        onClick={createCallback(pagination.next.from)}
                    >
                        <span aria-hidden="true">
                            <svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.2" fill="none"></path></svg>
                        </span>
                    </a>
                )}
            </div>
        </div>
    )
}
